module.exports = __webpack_public_path__ + "img/payout-caution.9d1c412f.svg";